import _typeof from "@babel/runtime/helpers/esm/typeof";
/**
 * The default parsing method for each step data
 *
 * @param {string | object} step
 * @returns {object}
 */
export var defaultStepMap = function defaultStepMap(step) {
  if (typeof step === 'string') {
    return {
      label: step
    };
  }
  return step;
};

/**
 * The parsing method for steps prop in ProgressStepper component.
 *
 * @param {array} steps - An array of step information.
 * @param {func} stepMap - Parsing method for each step.
 * @returns {array} - an array of parsed steps object.
 */
export var parseSteps = function parseSteps(steps, stepMap) {
  if (stepMap === void 0) {
    stepMap = defaultStepMap;
  }
  var parseStep = function parseStep(unparsedStep) {
    var step = unparsedStep;
    if (typeof stepMap === 'function') {
      step = stepMap(step);
    }
    if (_typeof(step) !== 'object') {
      throw new Error("Invalid step: expected an step of type \"object\", received: " + JSON.stringify(step));
    }
    if (!('label' in step)) {
      throw new Error("Invalid step: expected step to have property \"label\", received: " + JSON.stringify(step));
    }
    return step;
  };
  var parsedSteps = steps.reduce(function (parsed, step) {
    var parsedStep = parseStep(step);
    if (parsedStep) {
      parsed.push(parsedStep);
    }
    return parsed;
  }, []);
  return parsedSteps;
};